var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.24768 0C9.69259 0 12.4947 2.95111 12.4947 6.57919C12.4947 8.2909 11.871 9.85208 10.8503 11.0238L12.8587 13.1345C13.0467 13.3325 13.0473 13.6527 12.8593 13.8507C12.7657 13.9507 12.6419 14 12.5187 14C12.3962 14 12.273 13.9507 12.1787 13.852L10.1461 11.7173C9.07679 12.6191 7.72102 13.1591 6.24768 13.1591C2.80276 13.1591 0 10.2073 0 6.57919C0 2.95111 2.80276 0 6.24768 0ZM6.24768 1.01343C3.33329 1.01343 0.962267 3.50985 0.962267 6.57919C0.962267 9.64853 3.33329 12.1456 6.24768 12.1456C9.16142 12.1456 11.5324 9.64853 11.5324 6.57919C11.5324 3.50985 9.16142 1.01343 6.24768 1.01343Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.11db95825e01365f12c391f410d10be8.svg";
export { ForwardRef as ReactComponent };